const mutations = {
    SET_ERROR_TENANTS(state, payload) {
        state.error = payload;
    },
    SET_TENANT_BRANDING(state, payload) {
        state.tenantBranding = payload;
    },
    SET_CATALOG_PREVIEW(state, payload) {
        state.catalogPreview = payload;
    },
    CLEAR_CATALOG_PREVIEW(state) {
        state.catalogPreview = { data: null, tenantId: null, expiredAt: null };
    }
};

export default mutations;
